import { ProductCarousel } from '@app/components/various/ProductCarousel';
import { getStandardRelationProducts } from '@app/logic/products';
import { useLookbookProductsByIds } from '@app/services/hooks/lookbook/useLookbookProductsByIds';
import { isDefined } from '@app/utils/is';
import { isEmpty } from '@app/utils/isEmpty';
import { Product } from '@typings/@centra';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { LookbookProductCard, ReadonlyLookbookProductCard } from '../LookbookProductsList/LookbookProductCard';
import { ProductCardSkeleton } from '../ProductCard/ProductCardSkeleton';
import { useProductDetailsVariantContext } from '../ProductDetails/context/ProductDetailsVariantContext';
interface Props {
  isReadOnly: boolean;
  lookbookId: string;
}
export const LookbookRelatedProducts = ({ isReadOnly, lookbookId }: Props) => {
  const { t } = useTranslation(['products']);
  const { productDetails, variants } = useProductDetailsVariantContext();
  const standardRelationProductIds = React.useMemo(
    () =>
      isDefined(productDetails.relatedProducts) && isDefined(productDetails.relatedProducts.variants) ?
        [...new Set(getStandardRelationProducts(productDetails.relatedProducts.variants).map(({ product: productId }) => productId))]
      : [],
    [productDetails],
  );
  const { data, isLoading } = useLookbookProductsByIds({ lookbookId, products: standardRelationProductIds });

  const variantsToShow = React.useMemo(
    () => data?.filter(product => variants.some(variant => variant.product === product.product)) ?? [],
    [data, variants],
  );
  if (isEmpty(standardRelationProductIds)) {
    return null;
  }

  return (
    <ProductCarousel
      title={t('products:related_products')}
      skeletonComponent={<ProductCardSkeleton size="medium" />}
      isLoading={isLoading}
      products={variantsToShow}
      renderItem={(item: Product.Full) =>
        isReadOnly ? <ReadonlyLookbookProductCard productInfo={item} /> : <LookbookProductCard productInfo={item} />
      }
    />
  );
};
